<template>
  <div>
    <v-form>
      <v-container>
        <v-flex>
        <!-- <v-flex xs12 lg8> -->
          <v-row>
            <v-select
              v-model="selectedQuestionnaireType"
              :items="allQuestionnaires.length==0?[]:questionnaireTypes"
              :item-text="
                (item) => item.id + ' - ' + item.description
              "
              label="Questionnaire Type"
              presistent-hint
              return-object
            >
            </v-select>
            <v-spacer />
            <v-select
              v-model="selectedQuestionnaire"
              :items="questionnaires"
              :item-text="
                (item) => item.id + ' - ' + item.name
              "
              label="Questionnaire"
              presistent-hint
              return-object
            >
            </v-select>
          </v-row>
          <v-row>
            <!-- <v-row>
              <v-text-field
            :value="displayStartDate"
            label="Start Date"
            persistent-hint
            class="mr-2"
            append-icon="event"
            readonly
            required
            clearable
            style="margin-left: 12px;"
          ></v-text-field> -->
          <h4>Start date:</h4>
          <input style="margin-right: 50px; margin-left: 15px; border: 3px solid #bbb" type="date" v-model="startDate">
          <h4>End date:</h4>
          <input style="margin-right: 50px; margin-left: 15px; border: 3px solid #bbb" type="date" v-model="endDate">
          <v-btn style="margin-right: 10px;" @click="submit()">Submit</v-btn>
          <v-btn @click="clear()">Clear</v-btn>
          <v-btn style="margin-left: 15px;" @click="downloadCSV()" :disabled="this.selectedQuestionnaire === null">Download CSV</v-btn>
          <!-- <v-text-field
            :value="displayEndDate"
            label="End Date"
            persistent-hint
            class="mr-2"
            append-icon="event"
            readonly
            required
            clearable
          ></v-text-field> -->
        <!-- </v-row> -->
        <!-- <template>
            <div>
              <Datepicker v-model="selectedDate" :format="customDateFormat" :disabledDates="disabledDates" />
            </div>
          </template> -->
            <v-card width="1800px">
              <v-data-table
                :headers="dynamicHeaders"
                :items="dynamicData"
                :loading="loadingreports"
                item-key="id"
                class="elevation-10"
                @input="enterSelect($event)"
                show-select
                disable-pagination
                hide-default-footer>
              </v-data-table>
              <div style="height: 100px; display: flex; align-items: center; justify-content: center;">
            <v-row class="pagination" justify="center" align="center">
            <v-btn v-if="page > 1" @click="setPage(page - 1)">
              Previous
            </v-btn>
            <div style="margin-right: 30px; margin-left: 30px;">
              {{ page }}
            </div>
            <v-btn v-if="page < totalPages" @click="setPage(page + 1)">
              Next
            </v-btn>
            <div style="position: absolute; bottom: 0;">
              Total Number of pages: {{ totalPages }}
            </div>
            </v-row>
            </div>
            </v-card>
          </v-row>
          <!-- <v-row>
            <v-container>
              <v-flex>
                <v-btn @click="csvExport()" :disabled="!responseSelected">Download CSV</v-btn>
              </v-flex>
            </v-container>
          </v-row> -->
        </v-flex>
      </v-container>
    </v-form>
    <v-overlay :value="loadingreports" absolute>
      <v-card :loading="loadingreports" color="primary">
        <template slot="progress">
          <v-progress-linear
            color="white"
            height="5"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title>Loading reports...</v-card-title>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>

let rh = require('@/components/APIs/RequestHandler')

export default {
  data: function () {
    return {
      selectedResponses: [],
      responseSelected: false,
      dynamicHeaders: [
        {
          text: 'ID',
          align: 'start',
          sortable: true,
          value: 'userId'
        },
        { text: 'Email Address', value: 'emailAddress' },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Question 1' },
        { text: 'Answered On', value: 'answeredOn' }
      ],
      dynamicData: [],
      model: null,
      loadingreports: false,
      questionnaireTypes: [],
      selectedQuestionnaireType: null,
      selectedQuestionnaire: null,
      questionnaires: [],
      allQuestionnaires: [],
      userResponses: [],
      selectedDate: null,
      startDate: '',
      endDate: '',
      page: 1,
      totaluserresponses: 0,
      rowsPerPage: 10,
      totalnumberofpages: 1,
      submithit: false
    }
  },
  watch: {
    selectedQuestionnaireType: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setSelectedQuestionnaireType(newValue)
        }
      }
    },
    selectedQuestionnaire: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setSelectedQuestionnaire(newValue)
        }
      }
    }
  },
  props: [],
  computed: {
    totalPages () {
      if (this.totaluserresponses / this.rowsPerPage <= 1) {
        return 1
      } else {
        return Math.ceil(this.totaluserresponses / this.rowsPerPage)
      }
    }
  },
  methods: {

    created () {
      this.loadQuestionnaireTypes()
      this.loadAllQuestionnaires()
    },
    setPage (page) {
      if (page !== this.page) {
        this.page = page
        this.listUserReponsesToQuestionnaire(this.selectedQuestionnaire.id, page)
      }
    },
    setSelectedQuestionnaire (value) {
      this.page = 1
      this.listUserReponsesToQuestionnaire(value.id, this.page)
    },
    submit () {
      if (this.startDate !== '' || this.endDate !== '') {
        this.page = 1
        this.listUserReponsesToQuestionnaire(this.selectedQuestionnaire.id, this.page)
        this.submithit = true
      }
    },
    clear () {
      if ((this.startDate !== null || this.endDate !== null) && this.submithit) {
        this.startDate = ''
        this.endDate = ''
        this.page = 1
        this.listUserReponsesToQuestionnaire(this.selectedQuestionnaire.id, this.page)
        this.submithit = false
      }
    },
    setSelectedQuestionnaireType (value) {
      if (value !== null) {
        this.populateQuestionnaires(value.code)
      }
    },
    async populateQuestionnaires (questionnaireType) {
      this.questionnaires = []
      this.userResponses = []
      this.allQuestionnaires.data.forEach((value, index, array) => {
        if (value.typeCode === questionnaireType) {
          this.questionnaires.push(value)
        }
      })
    },
    async listUserReponsesToQuestionnaire (questionnaireId, page) {
      this.loadingreports = true
      this.userResponses = []
      this.dynamicData = []
      var index
      if ((this.startDate !== null || this.endDate !== null)) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires/${questionnaireId}/userResponses?startDate=${this.startDate}&endDate=${this.endDate}&pageNumber=${page}&pageSize=${this.rowsPerPage}`
      } else {
        endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires/${questionnaireId}/userResponses?startDate=&endDate=&pageNumber=${page}&pageSize=${this.rowsPerPage}`
      }
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.totaluserresponses = getResponse.data.totalRecords
      this.loadingreports = false
      this.dynamicHeaders = []
      var questHeader = {}
      questHeader['text'] = 'ID'
      questHeader['align'] = 'start'
      questHeader['sortable'] = 'true'
      questHeader['value'] = 'userId'
      this.dynamicHeaders.push(questHeader)

      questHeader = {}
      questHeader['text'] = 'Email Address'
      questHeader['value'] = 'emailAddress'
      this.dynamicHeaders.push(questHeader)

      questHeader = {}
      questHeader['text'] = 'First Name'
      questHeader['value'] = 'firstName'
      this.dynamicHeaders.push(questHeader)

      questHeader = {}
      questHeader['text'] = 'Last Name'
      questHeader['value'] = 'lastName'
      this.dynamicHeaders.push(questHeader)

      questHeader = {}
      questHeader['text'] = 'Phone Number'
      questHeader['value'] = 'phoneNumber'
      this.dynamicHeaders.push(questHeader)

      questHeader = {}
      questHeader['text'] = 'Answered On'
      questHeader['value'] = 'answeredOn'
      this.dynamicHeaders.push(questHeader)
      for (index in getResponse.data.formattedQuestionnaireResponse.questions) {
        questHeader = {}
        questHeader['text'] = getResponse.data.formattedQuestionnaireResponse.questions[index]
        questHeader['value'] = 'answers' + index
        this.dynamicHeaders.push(questHeader)
      }
      this.dynamicData = []
      for (index in getResponse.data.formattedQuestionnaireResponse.responses) {
        var data = getResponse.data.formattedQuestionnaireResponse.responses[index]
        data['id'] = index
        var i
        for (i in data.answers) {
          data['answers' + i] = data.answers[i]
        }
        this.dynamicData.push(data)
      }
      // this.dynamicData = getResponse.data.responses
    },
    initialize () {
      this.loadQuestionnaireTypes()
      this.loadAllQuestionnaires()
    },
    async loadQuestionnaireTypes () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires/types`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.questionnaireTypes = getResponse.data
    },
    async loadAllQuestionnaires () {
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires`
      this.allQuestionnaires = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      // this.allQuestionnaires = getResponse.data
    },
    enterSelect (selections) {
      this.selectedResponses = selections
      this.responseSelected = (selections.length !== 0)
    },
    csvExport () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      let rowText = []
      this.dynamicHeaders.forEach(function (header) {
        rowText.push('"' + header.text + '"')
      })
      let row = rowText.join(',')
      csvContent += row + '\r\n'
      this.selectedResponses.forEach(function (resp) {
        let row = resp.userId + ',' + resp.emailAddress + ',' + resp.firstName + ',' + resp.lastName + ',' + resp.phoneNumber + ',' + resp.answeredOn
        let answer = resp.answers.join(',')
        row = row + ',' + answer
        csvContent += row + '\r\n'
      })
      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', this.selectedQuestionnaire.name + '.csv')
      link.click()
    },
    async downloadCSV () {
      this.loadingreports = true
      this.submithit = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/document/downloadSurveyReport?questionnaire=${this.selectedQuestionnaire.id}-${this.selectedQuestionnaire.name}`
      endpoint = endpoint + `&startDate=${this.startDate}&endDate=${this.endDate}`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      // var file = getResponse.data
      var FILE = window.URL.createObjectURL(new Blob([getResponse.data]))
      // const data = encodeURI(file)
      const link = document.createElement('a')
      link.setAttribute('href', FILE)
      link.setAttribute('download', this.selectedQuestionnaire.name + '.csv')
      link.click()
      this.loadingreports = false
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
